(() => {
  angular
    .module('gm.common.directives')
    .directive('gmTouchMove', gmTouchMoveDirective);

  function gmTouchMoveDirective() {
    'ngInject';

    return {
      restrict: 'A',
      scope: {
        gmTouchMove: '&',
      },
      link(scope, element, _attrs) {
        function onTouchMove($event) {
          const method = scope.gmTouchMove;
          scope.$apply(() => method({ $event }));
        }
        element.bind('touchmove', onTouchMove);

        scope.$on('$destroy', () => {
          element.unbind('touchmove', onTouchMove);
        });
      }
    };
  }
})();
